<template>
  <div class="st-textarea-wrap">
    <textarea
      v-bind="attrs"
      v-model="model"
      class="st-control st-textarea"
      :class="{ 'st-control--shell': onShell }"
      :rows="rows"
      :style="tall && rows == null ? { minHeight: '120px' } : undefined"
    />
    <StIconButton
      class="st-textarea-copy"
      :icon="copied ? 'check' : 'copy'"
      :label="copied ? 'Copied text' : 'Copy text'"
      size="sm"
      :disabled="!model"
      @click="copyText"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, useAttrs } from 'vue';
import StIconButton from './StIconButton.vue';

defineOptions({ inheritAttrs: false });

const model = defineModel<string>();
const attrs = useAttrs();
defineProps<{
  onShell?: boolean;
  /** Taller default for long-form rules text (ignored when `rows` is set). */
  tall?: boolean;
  /** Explicit visible row count. */
  rows?: number;
}>();

const copied = ref(false);
let copiedTimer: ReturnType<typeof setTimeout> | null = null;

async function copyText() {
  if (!model.value) return;
  await navigator.clipboard.writeText(model.value);
  copied.value = true;
  if (copiedTimer) clearTimeout(copiedTimer);
  copiedTimer = setTimeout(() => {
    copied.value = false;
  }, 1200);
}
</script>

<style scoped>
.st-textarea-wrap {
  position: relative;
  display: flex;
  width: 100%;
}

.st-textarea {
  width: 100%;
  padding-right: calc(var(--st-control-h-sm) + var(--st-space-3));
}

.st-textarea-copy {
  position: absolute;
  top: var(--st-space-2);
  right: var(--st-space-2);
}
</style>
